export const URL = "https://www.palaxicinemas.com/webapi/";
export const UPLOADS="https://www.palaxicinemas.com/uploads/";
// export const URL = "http://localhost/palaxisite/webapi/";
// export const UPLOADS="http://localhost/palaxisite/uploads/";
